<template>
  <div>
    <!-- <header>
      <Header msg="Header" />
      <SettingsHeader msg="SettingsHeader" />
    </header> -->
    <main>
      <div class="userdata container">
        <div class="row name flex_center">
          <div class="headpic" v-if="picture">
            <img :src="picture" />
          </div>
          <router-link
            :to="{ path: (sdkType === 'sso' && isFooter !== 'true' ? 'web-name-edit' : 'name-edit'), query: $router.currentRoute.query }"
          >
            <a href="javascript:">
              <b>訂購人姓名</b>
              <span>{{ name }}</span>
            </a>
          </router-link>
        </div>

        <div class="row mobile">
          <router-link
            :to="{ path: (sdkType === 'sso' && isFooter !== 'true' ? 'web-mobile-edit' : 'mobile-edit'), query: $router.currentRoute.query }"
          >
            <a href="javascript:">
              <b>電話號碼</b>
              <span>{{ phone ? phone : "綁定手機驗證" }}</span>
            </a>
          </router-link>
        </div>

        <div class="row address_set flex_center flex_wrap">
          <div class="title flex_center">
            <b>常用地址</b>
            <router-link
              :to="{ path: (sdkType === 'sso' && isFooter !== 'true' ? 'web-address-edit' : 'address-edit'), query: $router.currentRoute.query }"
            >
              <a class="add-btn" href="javascript:">
                <i class="icon-add"></i> 儲存此地址
              </a>
            </router-link>
          </div>

          <div
            v-for="(address, index) in addresses"
            :key="index"
            class="address flex_center"
          >
            <input
              type="radio"
              name="address"
              :id="'add' + index"
              :checked="address.isDefault"
              v-on:change="changeDefault(address)"
            />
            <label :for="'add' + index">
              <i></i>
            </label>
            <router-link
              :to="{
                path: address.editLink,
                query: $router.currentRoute.query,
              }"
            >
              <a class="flex_center" :href="address.editLink">
                <span>
                  <b>{{ address.name }}</b>
                  {{ address.secondaryText }} {{ address.mainText }}
                  {{ address.aptSuiteFloor }}
                </span>
                <i class="icon_edit"></i>
              </a>
            </router-link>
            <a
              class="delete"
              href="#alert"
              v-on:click="setAddrToDel(address)"
              rel="modal:open"
            >
              <i class="icon-delete" v-show="address.id"></i>
            </a>
          </div>
          <div id="alert" class="modal notify">
            <ul>
              <li>
                刪除地址：
                <span class="add2"
                  >({{ addrToDel.name }}) {{ addrToDel.mainText }}
                  {{ addrToDel.aptSuiteFloor }}</span
                >？
              </li>
              <li>
                <a class="btn cancel" href rel="modal:close">取消</a>
                <a
                  class="btn submit"
                  href
                  v-on:click="delAddress(addrToDel)"
                  rel="modal:close"
                  >確定</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- END .userdata -->
    </main>
  </div>
</template>

<script>
// Guide:
// import './'  // 同一層目錄開始找
// import '../' // 上一層目錄開始找
// import '@/'  // src目錄下開始找
// import ''    // 直接打名稱則是node_modules

// @ is an alias to /src
// import Header from "@/components/Header.vue";
// import SettingsHeader from "@/components/SettingsHeader.vue";
import { Base64 } from "js-base64";
import apis from "@/services/apis";
import { authService } from "@/services/auth";

export default {
  name: "userData",
  data() {
    return {
      name: "",
      phone: "",
      picture: "",
      addrToDel: {},
      addresses: [],
      sdkType: GLOBAL_ENV_SDKTYPE
    };
  },
  // components: {
  //   SettingsHeader,
  //   Header,
  // },
  computed: {
    // userId() {
    //   return localStorage.getItem("lineUserId");
    // },
    userId() {
      let userId = localStorage.getItem("lineUserId");
      let userProfile = localStorage.getItem("lineUserProfile");
      let self = this;

      if (userProfile) {
        let userProfileObj = JSON.parse(Base64.decode(userProfile));
        // console.log('debug the user profile obj ' + JSON.stringify(userProfileObj));
        // console.log('vs ' + GLOBAL_ENV_LIFFID);
        if (
          !userProfileObj.liffApp ||
          userProfileObj.liffApp !== GLOBAL_ENV_LIFFID
        ) {
          userId = userProfile = null;
        }
      }
      return userId;
      // return localStorage.getItem("lineUserId");
    },
    uuid() {
      let uuid = localStorage.getItem("qcsso:uuid");
      console.log("compute the uuid " + uuid);
      let userProfile = localStorage.getItem("lineUserProfile");
      let self = this;

      // if (userProfile) {
      //   let userProfileObj = JSON.parse(Base64.decode(userProfile));
      //   // console.log('debug the user profile obj ' + JSON.stringify(userProfileObj));
      //   // console.log('vs ' + GLOBAL_ENV_LIFFID);
      //   if (
      //     !userProfileObj.liffApp ||
      //     userProfileObj.liffApp !== GLOBAL_ENV_LIFFID
      //   ) {
      //     uuid = userProfile = null;
      //   }
      // }
      return uuid;
      // return localStorage.getItem("lineUserId");
    },
    userProfile() {
      try {
        let obj = JSON.parse(
          Base64.decode(localStorage.getItem("lineUserProfile"))
        );
        return obj;
      } catch (e) {
        return {};
      }
    },
  },
  methods: {
    setUserLocalData(userId, byUuid) {
      let queryApi = apis.getUserProfile;

      if (byUuid) queryApi = apis.getSsoUserProfile;

      if (!userId) {
        console.log('missing uid');
        return new Promise((resolve, reject) => {
          resolve({});
        });
      }

      // return apis.getUserProfile(userId).then((profile) => {
      return queryApi(userId).then((profile) => {
        // console.log("the api profile response @ userdata " + JSON.stringify(profile));
        if (profile && profile.placeId) {
          let addrObj = {
            address: profile.address,
            mainText: profile.mainText,
            secondaryText: profile.secondaryText,
            placeId: profile.placeId
            // aptSuiteFloor: responses.aptSuiteFloor
          };
          // update address input
          // 把users那張表的address直接寫入cache可能會讓個人地址功能發生錯亂@@

          if (!localStorage.getItem("address")) {
            localStorage.setItem(
              "address",
              Base64.encode(JSON.stringify(addrObj))
            );
          }

          // console.log("set addr done");
          return profile;
        } else if (profile) {

          let currentData = this.userProfile;
          currentData.name = profile.displayName || profile.name;
          currentData.picture = profile.pictureUrl || profile.picture;
          currentData.phone = profile.phone;
          currentData.localPhone = profile.localPhone;
          localStorage.setItem(
            "lineUserProfile",
            Base64.encode(
              JSON.stringify(currentData)
            )
            // Base64.encode(
            //   JSON.stringify({
            //     name: profile.displayName || profile.name,
            //     picture: profile.pictureUrl || profile.picture,
            //     phone: profile.phone,
            //     localPhone: profile.localPhone,
            //   })
            // )
          );
        
        }
        return profile || {};
      });
    },
    changeDefault(address) {
      // 更新目前地址
      console.log("cache address " + JSON.stringify(address));
      localStorage.setItem("address", Base64.encode(JSON.stringify(address)));
      if (address && address.id) {
        if (GLOBAL_ENV_LIFFID === 'sso') {
          return apis.setSsoUserDefaultAddress(this.uuid, address.id);
        } else {
          return apis.setUserDefaultAddress(this.userId, address.id);
        }
        
      }
    },
    setAddrToDel(address) {
      this.addrToDel = address;
    },
    getCacheAddress() {
      if (!localStorage.getItem("address")) return {};
      else {
        let addrObj = JSON.parse(
          Base64.decode(localStorage.getItem("address"))
        );
        if (addrObj.placeId) return addrObj;
        else return null;
      }
    },
    getAddresses() {
      // 取出address list
      let self = this;

      let queryApi = apis.getUserAddresses;
      let uid = self.userId;
      let linkPath = 'address-edit';

      // if (this.$router.currentRoute.query.a === "sso") {
      if (GLOBAL_ENV_SDKTYPE === "sso") {
        queryApi = apis.getSsoUserAddresses;
        uid = self.uuid;
        
        if (this.isFooter !== 'true') {
          linkPath = 'web-address-edit';
        }
      }
      
      if (!uid) {
        console.log('missing uid');
        return new Promise((resolve, reject) => {
          resolve({});
        });
      }
        
      // return apis
      //   .getUserAddresses(self.userId)

      return queryApi(uid)
        .then(function(addresses) {
          let addrObj = self.getCacheAddress() || {};
          self.addresses = [];
          self.addresses.push({
            name: "目前使用位置",
            address: addrObj.address,
            mainText: addrObj.mainText,
            secondaryText: addrObj.secondaryText,
            aptSuiteFloor: addrObj.aptSuiteFloor,
            placeId: addrObj.placeId,
            isDefault: true,
            editLink: linkPath,
          });

          for (let i = 0; i < addresses.length; ++i) {
            self.addresses.push({
              id: addresses[i].id,
              name: addresses[i].name,
              address: addresses[i].address,
              mainText: addresses[i].mainText,
              secondaryText: addresses[i].secondaryText,
              aptSuiteFloor: addresses[i].aptSuiteFloor,
              placeId: addresses[i].placeId,
              isDefault: addresses[i].isDefault,
              editLink: linkPath + '/' + addresses[i].id,
            });
            if (addresses[i].isDefault) {
              self.changeDefault(addresses[i]);
            }
          }
        })
        .catch(function(e) {
          console.log("fetch user failed " + e.stack);
        });

      // return fetch(
      //   `${process.env.VUE_APP_APIHOST}/apis/addresses?user_id=${self.userId}`
      // )
      //   .then(res => res.json())
    },
    delAddress(address) {
      let self = this;
      let deleteApi = apis.delUserAddress;
      let uid = self.userId;

      // if (this.$router.currentRoute.query.a === "sso") {
      if (GLOBAL_ENV_SDKTYPE === "sso") {
        deleteApi = apis.delSsoUserAddress;
        uid = self.uuid;
      }

      if (address && address.id) {
        // return apis
        //   .delUserAddress(this.userId, address.id)
        return deleteApi(uid, address.id)
          .then((response) => {
            self.getAddresses();
          })
          .catch(function(e) {
            alert(e);
          });
      }
    },
  },
  mounted() {
    let self = this;

    this.getAddresses();

    if (GLOBAL_ENV_SDKTYPE === "sso") {
      let byUuid = true;
      this.setUserLocalData(this.uuid, byUuid).then(function(response) {
        // console.log(response);
        if (response && response.name) {
          self.name = response.name;
          self.picture = self.userProfile.picture || response.picture;
          self.phone = response.localPhone || response.phone;
          // console.log('api picture? ' + self.picture);
        }
      });
    } else {
      this.setUserLocalData(this.userId).then(function(response) {
        // console.log(response);
        if (response && response.name) {
          self.name = response.name;
          self.picture = self.userProfile.picture || response.picture;
          self.phone = response.localPhone || response.phone;
          // console.log('api picture? ' + self.picture);
        }
      });
    }

    this.name = this.userProfile.name;
    // 真的有遇到有手機怎樣liff都拿不到picture@@...怪到不行
    // 如果api也沒有就只好前端不顯示了，反正也沒什麼用
    this.picture = this.userProfile.picture || this.picture;

      // 有時候正確的回比較慢，會導致切換provider id變化時顯示錯誤
    this.subscription = authService.getUserId().subscribe((response) => {
      console.log('letter signined ' + GLOBAL_ENV_SDKTYPE);
      if (GLOBAL_ENV_SDKTYPE === "sso") {
        let byUuid = true;
        let uuid = localStorage.getItem("qcsso:uuid");
        
        console.log('user data letter authed ' + uuid);
        this.setUserLocalData(uuid, byUuid)
        .then(function(response) {
          // console.log(response);
          if (response && response.name) {
            self.name = response.name;
            self.picture = self.userProfile.picture || response.picture;
            self.phone = response.localPhone || response.phone;
            // console.log('api picture? ' + self.picture);
          }
        });
      } else {
        console.log('response ' + JSON.stringify(response));
        this.setUserLocalData(response.userId)
        .then(function(response) {
        // console.log(response);
        if (response && response.name) {
          self.name = response.name;
          self.picture = self.userProfile.picture || response.picture;
          self.phone = response.localPhone || response.phone;
          // console.log('api picture? ' + self.picture);
        }
      });
      }
    });


    // console.log(this.userProfile);
    // console.log('so what is our picture? ' + this.picture);

    // apis.getUserAddresses(this.userId)
    // .then(addresses => {
    //   console.log('the addresses ' + JSON.stringify(addresses));
    // });
  },
  props: ["type", "isFooter"],
};
</script>

<style scoped>
/* @import '../assets/css/theme_default.css'; */
div#alert {
  /* 吃不到global的只好補一下 */
  padding-top: 40px;
  text-align: center;
}
</style>
